import * as Yup from "yup";
import { GET_VENDORS, GET_PROJECTS_LIST } from "utils/graphql/services/live-classes/queries";

export const table = {
  primaryData: [
    {
        title: "ID",
        value: "id",
        type: "configue",

    },
    {
        title: " Name",
        value: "name",
        type: "configue",
      
    },
    {
        title: "Created At",
        value: "createdAt",
        type: "configue",
    },
    {
        title: "Updated At",
        value: "updatedAt",
        type: "configue",
        name: "updatedAt"
    },
    {
        title: "CreatedBy",
        value: "createdByName",
        type: "configue",
    },
    {
        title: "Updated By",
        value: "updatedByName",
        type: "configue",
        name: "updatedByName"
    }
  ],
  secondaryData: [],
};

export type platforms = {
  id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
    createdById: string;
    updatedById: string;
    createdByName: string;
    updatedByName: string;
};

export const platformsInitialValues: platforms = {
   id: "",
    name: "",
    createdAt: "",
    updatedAt: "",
    createdById: "",
    updatedById: "",
    createdByName: "",
    updatedByName: "",
  
};

export const platformMandatoryFields = ["name"];

export const platformValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),  
});

export const platformProperties = [
  {
        id: "ID",
        type: "text",
        label: `ID`,
        className: "name-styles",
        breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
        required: true,
    },
    {
        id: "Name",
        type: "text",
        label: `Name`,
        className: "name-styles",
        breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
        required: true,
    },
    {
        id: "createdAt",
        type: "date-picker",
        label: `Created At`,
        className: "name-styles",
        breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
        required: false,
    },
    {
        id: "updatedAt",
        type: "date-picker",
        label: `Updated At`,
        className: "name-styles",
        breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
        required: false,
    },
    {
        id: "createdById",
        type: "text",
        label: `Created By Id`,
        className: "name-styles",
        breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
        required: false,
    },
    {
        id: "updatedById",
        type: "text",
        label: `Updated By Id`,
        className: "name-styles",
        breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
        required: false,
    },
];
